/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import { AgGridReact } from "ag-grid-react"
import { FlightTableTab } from "../../containers/selectionSlice"
import { useAppSelector } from "../../app/hooks"
import useIsDesktopWidth from "../../hooks/useIsDesktopWidth"
import { ColDef, SelectionChangedEvent } from "ag-grid-community"
import _ from "lodash"
import {
  DataEditTableTopBar,
  DataEditTableTopBarProps
} from "./DataEditTableTopBar"

interface Props extends DataEditTableTopBarProps {
  columns: ColDef[]
  rowData: any
  onSelect: (rowData: any) => void
}

export const DataEditTableGrid: React.FunctionComponent<Props> = ({
  columns,
  rowData,
  actions,
  onSelect
}) => {
  const [checkBoxColumns, setCheckBoxColumns] = useState(columns)
  const isDesktopWidth = useIsDesktopWidth()
  const { chosenFlightTableTab } = useAppSelector(
    (state) => state["selectionReducer"].flightTableSelection
  )

  const handleSelectionChanged = (event: SelectionChangedEvent) => {
    const selectedNodes = event.api.getSelectedNodes()
    onSelect(selectedNodes.length > 0 ? selectedNodes[0].data : null)
  }

  useEffect(() => {
    const updColumns = _.cloneDeep(checkBoxColumns)
    updColumns[0].checkboxSelection = true
    updColumns[0].headerCheckboxSelection = true
    setCheckBoxColumns(updColumns)
  }, [])

  const RowHeightMap = {
    [FlightTableTab.condensed]: 28,
    [FlightTableTab.default]: 40,
    [FlightTableTab.spacious]: 48
  }

  return (
    <div
      className={
        "ocs-view-flights-table-container" +
        (chosenFlightTableTab === FlightTableTab.condensed
          ? " ocs-condensed-table"
          : "") +
        (chosenFlightTableTab === FlightTableTab.spacious
          ? " ocs-spacious-table"
          : "")
      }
    >
      <DataEditTableTopBar actions={actions} />
      <div className={"ocs-table-grid ag-theme-alpine max-row-width"}>
        <AgGridReact
          columnDefs={checkBoxColumns}
          rowData={rowData}
          defaultColDef={{ sortable: false }}
          onGridReady={(params) => {
            if (isDesktopWidth) {
              params.api.sizeColumnsToFit()
            }
          }}
          onFirstDataRendered={(params) => {
            params.columnApi.autoSizeAllColumns()
          }}
          onComponentStateChanged={(params) => {
            params.columnApi.autoSizeAllColumns()
            params.api.resetRowHeights()
          }}
          rowSelection="single"
          suppressRowClickSelection
          suppressRowHoverHighlight
          onSelectionChanged={handleSelectionChanged}
          rowHeight={RowHeightMap[chosenFlightTableTab]}
        />
      </div>
    </div>
  )
}

